import React, { useEffect, useState } from 'react';
import { getPublicTickets } from '../api';

const PublicTickets = () => {
  const [tickets, setTickets] = useState([]);

  useEffect(() => {
    const fetchTickets = async () => {
      try {
        const response = await getPublicTickets();
        setTickets(response.data);
      } catch (error) {
        console.error('Failed to fetch public tickets:', error);
      }
    };
    fetchTickets();
  }, []);

  return (
    <div>
      <h2 className="text-2xl font-bold mb-4">Public Tickets</h2>
      {tickets.length > 0 ? (
        <ul>
          {tickets.map((ticket, index) => (
            <li key={index} className="mb-4 p-4 bg-white rounded shadow">
              <h3 className="font-bold">{ticket.title}</h3>
              <p><strong>Category:</strong> {ticket.category}</p>
              <p><strong>Description:</strong> {ticket.description}</p>
              <p><strong>Status:</strong> {ticket.status}</p>
            </li>
          ))}
        </ul>
      ) : (
        <p>No public tickets found.</p>
      )}
    </div>
  );
};

export default PublicTickets;